<script>
import Contact from "@/components/Contact.vue";
import axios from "axios";
// import axios from 'axios';
// import CustomBoxes from "@/components/CustomBoxes.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  components: {
    Contact
  },
  data() {
    return {
      showModal: false,
      form: {
        name: '',
        phone: '',
        email: '',
        message: '',
        file: [],
      },
      show: true
    }
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault()
      try {
        const formData = new FormData();
        formData.append('name', this.form.name);
        formData.append('phone', this.form.phone);
        formData.append('email', this.form.email);
        formData.append('description', this.form.message);
        const response = await axios.post('https://xiyuepack.com/tiger/quote', formData, {
        //   const response = await axios.post('http://127.0.0.1:4000/tiger/quote', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        console.log('请求成功:', response.data);
        this.showModal=false;
        this.$bvToast.toast('success', {
          title: 'Request A Quote',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        console.error('请求失败:', error);
        this.$bvToast.toast('failed', {
          title: 'Request A Quote',
          variant: 'danger',
          solid: true,
        })
      }
    },
    onReset(event) {
      event.preventDefault()
      this.form.name = ''
      this.form.phone = ''
      this.form.email = ''
      this.form.message = ''
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    onContact(event) {
      event.preventDefault()
      this.showModal = true
    }
  }
}

</script>

<template>
  <div class="w-100">
    <b-navbar type="light" variant="white" class="w-100">
      <b-navbar-brand href="/home">
        <b-img src="@/assets/brand.png" width="122" height="50"></b-img>
      </b-navbar-brand>
      <!--      <b-img src="@/assets/logo1.png" fluid></b-img>-->
      <!--      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>-->
      <!--      <b-collapse id="nav-collapse" is-nav>-->
      <b-navbar-nav class="ml-auto">
        <b-nav-item to="/home">Home</b-nav-item>
        <b-nav-item-dropdown text="Products">
          <b-dropdown-item to="/customBoxes">Custom Boxes</b-dropdown-item>
          <b-dropdown-item to="/customBags">Custom Bags</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item to="/faq">FAQs</b-nav-item>
        <b-nav-item to="/about">About</b-nav-item>
        <!--          <b-nav-item v-b-toggle.sidebar-1>Contact</b-nav-item>-->
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-form>
          <b-button variant="success" size="sm" class="my-2 my-sm-0" type="button" @click="onContact">Contact Us
          </b-button>
        </b-nav-form>

      </b-navbar-nav>
      <!--      </b-collapse>-->
    </b-navbar>
    <b-modal class="modal" v-model="showModal" title="Contact Us">
      <div class="ml-3 mr-3" align="left">
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
          <b-form-group
              id="input-group-1"
              label="Name*"
              label-for="input-1"
          >
            <b-form-input
                id="input-1"
                v-model="form.name"
                placeholder="Enter your name"
                required></b-form-input>

          </b-form-group>
          <b-form-group
              id="input-group-2"
              label="Phone*"
              label-for="input-2"
          >
            <b-form-input
                id="input-2"
                v-model="form.phone"
                type="tel"
                placeholder="Enter Phone"
                required
            ></b-form-input>
          </b-form-group>
          <b-form-group
              id="input-group-3"
              label="Email*"
              label-for="input-3"
          >
            <b-form-input
                id="input-3"
                v-model="form.email"
                type="email"
                placeholder="Enter email"
                required
            ></b-form-input>
          </b-form-group>
          <b-form-group
              id="textarea-group-4"
              label="Message"
              label-for="textarea"
          >
            <b-form-textarea
                id="textarea"
                v-model="form.message"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
          </b-form-group>
<!--          <b-form-group-->
<!--              id="textarea-group-5"-->
<!--              label="File Upload"-->
<!--              label-for="upload"-->
<!--          >-->
<!--            <b-form-file id="upload"-->
<!--                         drop-placeholder="Click or drop files to upload"-->
<!--                         v-model="form.file"-->
<!--                         multiple-->
<!--            ></b-form-file>-->
<!--          </b-form-group>-->
          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
      </div>
      <template #modal-footer>
        <b-button @click="showModal = false">关闭</b-button>
      </template>
    </b-modal>
    <Contact v-model:showModal="showModal"></Contact>
    <b-sidebar id="sidebar-1" title="Send Us A Message" width="640px" backdrop-variant="dark" backdrop shadow>

    </b-sidebar>
  </div>
</template>

<style scoped lang="scss">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>